import { render, staticRenderFns } from "./Form2.vue?vue&type=template&id=5be67ff0&scoped=true&"
import script from "./Form2.vue?vue&type=script&lang=js&"
export * from "./Form2.vue?vue&type=script&lang=js&"
import style0 from "./Form2.vue?vue&type=style&index=0&id=5be67ff0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be67ff0",
  null
  
)

export default component.exports